/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import ApiNew from "./Api";
import Marquee from "react-fast-marquee";

function SSoft_Our_Client() {
  const [sectionClientLogo, setClientLogo] = useState([]);
  const [sectionText, setSectionText] = useState();
  const activeLang = useSelector((state) => state.content.activeLanguage);

  useEffect(() => {
    const fetchData = async () => {
      const api = new ApiNew();
      const sectionResponse = await api.getSectionDetail({
        language: activeLang,
      });
      const sectionData = sectionResponse.data.results[0];

      setClientLogo(sectionData.widgets[1]?.widget_contents || []);
      setSectionText(...(sectionData.widgets[0]?.widget_contents || []));
    };

    fetchData();
  }, [activeLang]);

  // Keep your pair grouping logic if you want two logos grouped like before
  let combinedItems = [];
  if (sectionClientLogo && sectionClientLogo.length) {
    combinedItems = sectionClientLogo.reduce((acc, data, index) => {
      if (index % 2 === 0) {
        acc.push({
          id: index,
          data: [data, sectionClientLogo[index + 1] || null],
        });
      }
      return acc;
    }, []);
  }

  // Marquee props to tune:
  // speed: number - larger = faster
  // direction: "left" moves content leftwards (i.e., right -> left visual)
  // pauseOnHover / pauseOnClick
  // gradient: optional fading edges; set false to avoid fade
  const marqueeProps = {
    speed: 40, // tune to taste (default 50). smaller => slower
    direction: "left", // content moves left (right -> left visual flow)
    pauseOnHover: true,
    pauseOnClick: false,
    gradient: false,
    // If you want continuous without gap, set 'loop' infinite (default)
  };

  return sectionClientLogo.length !== 0 ? (
    <div className="w-full h-full py-[120px]  section-container section-margin-x ">
      <div className="flex justify-center">
        <h1 className="header-style-non-hero text-center mb-4 max-w-[780px]">
          {sectionText && sectionText.content}
        </h1>
      </div>

      <div className="pt-[70px] hd2xl:max-w-[1750px] hd2xl:mx-auto min-h-[95px]">
        <Marquee {...marqueeProps} className="w-full">
          {/* render each grouped item as a block similar to your SplideSlide */}
          {combinedItems.map((item) => (
            <div
              key={item.id}
              className="w-[200px] flex flex-col justify-between gap-y-[25px] s:gap-y-[35px] px-4"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {item.data.map((data, id) => {
                if (!data) return null;
                return (
                  <div
                    key={data.id}
                    className={`w-full max-h-[35px] ${
                      id === 1 ? "flex justify-end" : ""
                    }`}
                  >
                    <img
                      className="max-w-[100px] max-h-[35px] cursor-pointer"
                      src={data?.file_medium || data?.file}
                      alt={data.description || "client logo"}
                    />
                  </div>
                );
              })}
            </div>
          ))}
        </Marquee>
      </div>
    </div>
  ) : (
    <Box className="w-full h-[253px]" />
  );
}

export default SSoft_Our_Client;
